import React from "react";

import DefaultManager from "./Default.manager";

class AmatiSempreManager extends DefaultManager {
  signboardId;

  constructor(signboardId) {
    super(signboardId);
    this.signboardId = signboardId;
  }

  getInshopUrl()
  {
    if(this.signboardId == 7224)
      return 'https://app.inpublish.it/checkout/site/index?params=';

    return super.getInshopUrl()
  }
}

export default AmatiSempreManager;
